import { UnicodeEntity } from '@mews/enums';

export const MAX_BANK_NAME_LENGTH = 22;
export const OMISSION_STRING = UnicodeEntity.Ellipsis;
